
export function limitWordsAndSpaces(text, maxWords) {
  let wordCount = 0;
  let lastIndex = 0;
  text.replace(/\S+/g, (match, index) => {
    wordCount++;
    if (wordCount === maxWords) {
      lastIndex = index + match.length;
    }
  });

  if (wordCount < maxWords) {
    return text;
  }

  // Slice up to the last word and remove any trailing spaces
  return text.slice(0, lastIndex);
}